<template>
  <b-container>
    <div id="big-effect-pdf">
      <div class="answer-examination-test-back">
        <div class="student-answer-information">
          <b-row>
            <EndHead :result="result" @downPdf="downPdf"> </EndHead>
          </b-row>
          <BigEndForm :result="result"> </BigEndForm>
        </div>
      </div>
      <div class="student-score-information">
        <EndForm
          :score="score"
          :subjectiveColor="`#2cb774`"
          :objectiveColor="`#FFC13B`"
          :objectiveTest="`客观题`"
          :subjectiveTest="`主观题`"
        >
        </EndForm>
      </div>
      <div class="student-test-information">
        <EndTest
          :sections="sections"
          :unfold="unfold"
          @getQuestions="getQuestions"
          @addWriteAnsers="addWriteAnsers"
          @changeRadio="changeRadio"
          @filterHtml="filterHtml"
        >
        </EndTest>
      </div>
    </div>
  </b-container>
</template>

<script>
import {
  getEngReport,
  getSectionAnswerRecords,
} from "@/api/english-examination";
import EndForm from "@/components/english-end/end-form.vue";
import EndTest from "@/components/english-end/end-test.vue";
import EndHead from "@/components/english-end/end-head.vue";
import BigEndForm from "./components/big-end-form.vue";
export default {
  data() {
    return {
      result: "",
      score: {},
      sections: "",
      unfold: [true, true, true, true, true, true, true, true],
    };
  },
  components: {
    EndForm,
    EndTest,
    EndHead,
    BigEndForm,
  },
  mounted() {
    this.getSections();
    this.sections = this.simulationExamQuestions;
  },
  methods: {
    downPdf() {
      this.getPdf("big-effect-pdf");
    },
    returnHome() {
      this.$router.replace({
        name: "HomeIndex",
      });
    },
    getSections(id = this.$route.query.studentExamId) {
      this.check = false;
      this.unfold = [true, true, true, true, true, true, true, true];
      // debugger;

      if (id) {
        getEngReport({ recordExamId: this.$route.query.studentExamId }).then(
          (res) => {
            this.result = res.data.result.engFinishSummary;
            this.sections = res.data.result.examSectionInfos;
            this.score = res.data.result.scoreDistribution;
            // this.setSimulationExamQuestions(this.sections);
            // this.userAnswersInit();
            this.testData = res.data.result;
            console.log("this.testData", this.testData);
          }
        );
      }
    },
    changeRadio(value, questionId, setionId) {
      console.log("模拟试卷", this.answers);
      for (const a of this.answers.answerSectionInputs) {
        if (a.sectionId === setionId) {
          let isHave = false;
          for (const b of a.answerQuestionInputs) {
            if (b.questionId === questionId) {
              b.answer = value;
              isHave = true;
              break;
            }
          }
          if (!isHave) {
            a.answerQuestionInputs.push({
              questionId: questionId,
              answer: value,
            });
          }
        }
      }
      this.setUserAnswers(this.answers);
    },
    // 非听力展开试题
    getQuestions(simIndex, sectionId) {
      console.log("sectionId", sectionId, "simIndex", simIndex);
      // debugger;
      this.$set(this.unfold, simIndex, !this.unfold[simIndex]);
      if (this.sections[simIndex].simulationSections) {
        return;
      }
      getSectionAnswerRecords({ sectionId: sectionId }).then((res) => {
        console.log("res", res);
        // debugger;
        res.data.result.sectionAnswerRecordsInfos.simulationExamQuestions =
          res.data.result.sectionAnswerRecordsInfos.sectionAnswerRecords;
        this.$set(
          this.sections[simIndex],
          "simulationSections",
          res.data.result.sectionAnswerRecordsInfos
        );
        this.setSimulationExamQuestions(this.sections);
        if (this.sections[simIndex].sectionType === 8) {
          this.addWriteAnsers(
            simIndex,
            res.data.result.sectionAnswerRecordsInfos
          );
        }
        console.log("模块试题", this.sections);
      });
    },
    addWriteAnsers(index, questions) {
      for (const a of questions) {
        for (const b of a.simulationExamQuestions) {
          this.answers.answerSectionInputs[index].answerQuestionInputs.push({
            selfScore: "",
            questionId: b.questionId,
            answer: "",
          });
        }
      }
      this.setUserAnswers(this.answers);
    },
    filterHtml(html, arr) {
      const dom = document.createElement("div");
      dom.innerHTML = html;
      const inputList = dom.getElementsByTagName("input");
      Array.prototype.forEach.call(inputList, (item, i) => {
        // debugger;

        const span = document.createElement("span");
        let color = "#CC0000";
        let standardAnswerKeySpan = `
          <span style="font-weight: bold;color: #000000;">（<span style="font-weight: normal;color: #2CB774">${arr[i].standardAnswerKey}</span>）</span>
        `;
        if (arr[i].userAnswerKey === arr[i].standardAnswerKey) {
          standardAnswerKeySpan = "";
          color = "#2CB774";
        }

        span.innerHTML = `<span class="text_unline" style="padding: 0 20px;box-sizing: border-box;  border-bottom: 1px solid #000000;color: ${color}">${arr[i].userAnswerKey}${standardAnswerKeySpan}</span>`;
        item.value = arr[i].standardAnswerKey;
        item.style.display = "none";
        item.setAttribute("attr_name", "attr_value" + i);
        item.parentNode.insertBefore(span, item);
        // item.parent.removeChild(item)
        console.log("input", item);
        // this.filterHtml(html, arr)
      });
      return dom.innerHTML;
    },
  },
};
</script>

<style lang="scss" scoped>
.answer-examination-test-back {
  letter-spacing: 1px;
  .student-answer-information {
    background-color: #ffffff;
    min-height: 40rem;
    border-radius: 10px;
    padding: 3rem 2rem;
    position: relative;
  }
}
.student-score-information {
  background-color: #ffffff;
  min-height: 40rem;
  border-radius: 10px;
  padding: 3rem 2rem;
  margin: 1rem 0;
}
.student-test-information {
  background-color: #ffffff;
  min-height: 40rem;
  border-radius: 10px;
  padding: 3rem 2rem;
}
</style>>
